module.exports = __webpack_public_path__ + "img/airport-nodoor.1eb0b2e9.png";